export const currencyOption = [
  { label: "USD", value: "USD" },
  { label: "CHF", value: "CHF" },
  { label: "EUR", value: "EUR" },
  { label: "KYD", value: "KYD" },
  { label: "INR", value: "INR" },
  { label: "GBP", value: "GBP" },
  { label: "GIP", value: "GIP" },
  { label: "JOD", value: "JOD" },
  { label: "OMR", value: "OMR" },
  { label: "BHD", value: "BHD" },
];

export const unitOption = [
  { label: "Per hour", value: "HOUR" },
  { label: "Per month", value: "MONTH" },
  { label: "Per annum", value: "ANNUM" },
];
//these regax are used at job description of add and update job pages
export const jobDescriptionRegax = /(<([^>]+)>)/gi;
export const jobDescriptionRegax2 = /&nbsp;/gi;
export const jobDescriptionRegax3 = /\s+/g;
export const IN_PROGRESS = "In Progress";
export const CANDIDATE_STAGE = {
  APPLIED: "APPLIED",
  SCREEN: "SCREEN",
  SHORTLIST: "SHORTLIST",
  INTERVIEW: "INTERVIEW",
  DOCUMENTVERIFICATION: "DOCUMENTVERIFICATION",
  HIRE: "HIRE",
  HIRED: "HIRED",
  REJECTED: "REJECTED",
  SELECTED: "SELECTED",
  REJECT: "REJECT",
  ALL: "ALL",
  SCHEDULED: "SCHEDULED",
  COMPLETED: "COMPLETED",
  ACCEPTED: "ACCEPTED",
  S_REVIEW: "S_REVIEW",
  JD_REVIEW: "JD_REVIEW",
  S_JD_REVIEW: "S_JD_REVIEW",
  REVIEWED: "REVIEWED",
  IN_PROGRESS: "IN_PROGRESS",
  INPROGRESS: "INPROGRESS",
  OFFER: "OFFER",
  DOCUMENT: "DOCUMENT",
  OFFERLETTER: "OFFERLETTER",
  DECISION: "DECISION",
  AFTER_SCREENING: "AFTER_SCREENING",
  BEFORE_SCREENING: "BEFORE_SCREENING",
  CANCELLED: "CANCELLED",
  HOLD: "HOLD",
  REVOKED: "REVOKED",
  ASSESSMENT: "ASSESSMENT",
  OVERRIDE: "OVERRIDE",
  FAIL: "FAIL",
  PASS: "PASS",
  DELETED: "DELETED",
  APPROVED: "APPROVED",
  RECEIVED: "RECEIVED",
};
export const DASHBOARD_BAR_CHART_CANDIATE_HIRED_COLOR = "#34c38f";
export const DASHBOARD_BAR_CHART_CLIENT_JOBS_COLOR = "#3b5de7";

// we are using this object in Ai-markup popup
export const COUNTER_STATUS = {
  INCREMENT: "INCREMENT",
  DECREMENT: "DECREMENT",
  SCREEN_START: "SCREEN_START",
  SCREEN_END: "SCREEN_END",
  SHORTLIST_START: "SHORTLIST_START",
  SHORTLIST_END: "SHORTLIST_END",
  INTERVIEW_START: "INTERVIEW_START",
  INTERVIEW_END: "INTERVIEW_END",
};

//add candidate nationalitiesList
export var nationalitiesList = [
  "Afghan",
  "Albanian",
  "Algerian",
  "Argentine/Argentinian",
  "Australian",
  "Austrian",
  "Bangladeshi",
  "Belgian",
  "Bolivian",
  "Batswana",
  "Brazilian",
  "Bulgarian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Czech",
  "Danish",
  "Dominican",
  "Ecuadorian",
  "Egyptian",
  "Salvadorian",
  "English",
  "Estonian",
  "Ethiopian",
  "Fijian",
  "Finnish",
  "French",
  "German",
  "Ghanaian",
  "Greek",
  "Guatemalan",
  "Haitian",
  "Honduran",
  "Hungarian",
  "Icelandic",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kenyan",
  "Kuwaiti",
  "Lao",
  "Latvian",
  "Lebanese",
  "Libyan",
  "Lithuanian",
  "Malagasy",
  "Malaysian",
  "Malian",
  "Maltese",
  "Mexican",
  "Mongolian",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nepalese",
  "Dutch",
  "New Zealand",
  "Nicaraguan",
  "Nigerian",
  "Norwegian",
  "Pakistani",
  "Panamanian",
  "Paraguayan",
  "Peruvian",
  "Philippine",
  "Polish",
  "Portuguese",
  "Romanian",
  "Russian",
  "Saudi",
  "Scottish",
  "Senegalese",
  "Serbian",
  "Singaporean",
  "Slovak",
  "South African",
  "Korean",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajikistani",
  "Thai",
  "Tongan",
  "Tunisian",
  "Turkish",
  "Ukrainian",
  "Emirati",
  "British",
  "American",
  "Uruguayan",
  "Venezuelan",
  "Vietnamese",
  "Welsh",
  "Zambian",
  "Zimbabwean",
  "USA",
];

//add candidate country list
export var CountryList = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antarctica",
  "Argentina",
  "Australia",
  "Austria",
  "Bahrain",
  "Bangladesh",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bolivia",
  "Brazil",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Dijbouti",
  "Ecuador",
  "Egypt",
  "Equatorial Guinea",
  "Estonia",
  "Ethiopia",
  "Faroe Islands",
  "Finland",
  "France",
  "French Guiana",
  "Gabon",
  "Germany",
  "Greece",
  "Greenland",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea Bissau",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Korea",
  "Kuwait",
  "Latvia",
  "Lebanon",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Malaysia",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mayotte",
  "Mexico",
  "Moldova",
  "Monaco",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nigeria",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "San Marino",
  "Saudi Arabia",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen Islands",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vatican City State (Holy See)",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (US)",
];

// add candidate unitOptions
export const addCandidateunitOption = [
  { label: "Per hour", value: "HOUR" },
  { label: "Per month", value: "MONTH" },
  { label: "Per annum", value: "ANNUM" },
];

export const proficiencyOption = [
  { label: "Proficient", value: "PROFICIENT" },
  { label: "Moderate", value: "MODERATE" },
  { label: "Native", value: "NATIVE" },
];

//add candidate referenceOptions
export const referenceOptions = [
  {
    label: "Person managed you directly",
    value: "Person managed you directly",
  },
  {
    label: "Person reported directly to you",
    value: "Person reported directly to you",
  },
  {
    label: "Person was senior to you but didn't manage directly",
    value: "Person was senior to you but didn't manage directly",
  },
  {
    label: "You were senior to Person but didn't manage directly",
    value: "You were senior to Person but didn't manage directly",
  },
  {
    label: "You were worked with Person in the same group",
    value: "You were worked with Person in the same group",
  },
  {
    label: "You were worked with Person but in different groups",
    value: "You were worked with Person but in different groups",
  },
  {
    label: "Person were worked with you but in different groups",
    value: "Person were worked with you but in different groups",
  },
  {
    label: "Person were worked with you but at different companies",
    value: "Person were worked with you but at different companies",
  },
  {
    label: "You were a client of Person's",
    value: "You were a client of Person's",
  },
  {
    label: "Person was a client of yours",
    value: "Person was a client of yours",
  },
  { label: "Person taught you", value: "Person taught you" },
  { label: "Person mentored you", value: "Person mentored you" },
  {
    label: "You were stutdents together",
    value: "You were stutdents together",
  },
  {
    label: "Other",
    value: "Other",
  },
];

// add canidate document options
export const optionGroup = [
  {
    label: "Select In",
    options: [
      { label: "PAN Number", value: "PANNumber" },
      { label: "Driving License No", value: "LicenseNo" },
      { label: "Unique Id", value: "UniqueId" },
      { label: "Passport Number", value: "PassportNumber" },
    ],
  },
];

export const titleOption = [
  { label: "Select Title", value: "" },
  { label: "MR.", value: "MR" },
  { label: "MS.", value: "MS" },
  { label: "MISS.", value: "MISS" },
  { label: "MRS.", value: "MRS" },
  { label: "OTHER", value: "OTHRES" },
];
export const genderOption = [
  { label: "Select Gender", value: "" },
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];
export const maritalOption = [
  { label: "Select Marital Status", value: "" },
  { label: "Single", value: "SINGLE" },
  { label: "Married", value: "MARRIED" },
  { label: "Separated", value: "SEPARATED" },
  { label: "Divorced", value: "DIVORCED" },
  { label: "Other", value: "OTHERS" },
];
// { label: "Select Nationality", value: " " },
// { label: "Indian", value: "Indian" },
// { label: "American", value: "American" },
// { label: "Others", value: "Others" }
export const visaOption = [
  { label: "Select Visa Status", value: "" },
  { label: "Active", value: "Active" },
  { label: "In-Active", value: "In-Active" },
];
export const stateOption = [
  { label: "Select State", value: "" },
  { label: "Punjab", value: "Punjab" },
  { label: "Delhi", value: "Delhi" },
];
export const countryOption = [
  { label: "Select Country", value: "" },
  { label: "India", value: "India" },
  { label: "USA", value: "USA" },
];
export const degreeOptionGroup = [
  { label: "BTech.", value: "BTech." },
  { label: "MBA", value: "MBA" },
  {
    label: "Master of Business Administration",
    value: "Master of Business Administration",
  },
];
const specializationOption = [
  { label: "Software Engineering", value: "Software Engineering" },
  { label: "Civil", value: "Civil" },
];
export const instituteOption = [
  { label: "University of Mumbai", value: "University of Mumbai" },
  { label: "Panjab University", value: "Panjab University" },
];
export const instituteTypeOption = [
  { label: "School", value: "SCHOOL" },
  { label: "College", value: "COLLEGE" },
  { label: "University", value: "UNIVERSITY" },
  { label: "Board", value: "BOARD" },
];
export const measureTypeOption = [
  { label: "CGPA", value: "CGPA" },
  { label: "GPA", value: "GPA" },
  { label: "Percentage", value: "PERCENTAGE" },
];
export var columns = [
  { label: "Name", field: "name" },
  { label: "Email", field: "email" },
  { label: "Status", field: "statusMessage" },
  { label: "Role", field: "roleName" },
];

export const usermanagementOptionGroup = [
  {
    label: "Select type",
    options: [
      { label: "All Users", value: "ALL" },
      { label: "Active Users Only", value: "ACTIVE" },
      { label: "In-Active Users Only", value: "INACTIVE" },
    ],
  },
];

//microsoft teams tooltip text
export const microsoftText = "Only for microsoft business account";
//zoom meet tooltip text
export const zoomText = "coming soon";
export const HireNeuronText = "coming soon";

export const UploadFileValidation = {
  AcceptedKbSize: 5000,
  AcceptedMbSize: 5,
  AcceptedFilesType: [".png", ".jpg", ".jpeg", ".docx", ".pdf", ".xlsx"],
  defaultMessage:
    "Please upload a valid document(.png, .jpg, .jpeg, .docx, .pdf, .xlsx)",
  errorSize: "Please upload a document with less than 5 mb size",
};

export const AppsList = {
  ZOOM: "Zoom",
  MS_TEAMS: "Microsoft Teams",
  SALES_FORCE: "Sales Force",
  GOOGLE_MEET: "Google Meet",
  HIRE_NEURON: "Hire Neuron",
};
export const DefaultPaginationConfig = {
  SIZE: 50,
  MAPPEDCANDIDATE_PAGESIZE: 10,
};
export const CAREERPAGEINTEGRATIONSTATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
};

export const API_REQ_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
};
